import { render, staticRenderFns } from "./CoolingDevice.vue?vue&type=template&id=07610120&scoped=true&"
import script from "./CoolingDevice.vue?vue&type=script&lang=js&"
export * from "./CoolingDevice.vue?vue&type=script&lang=js&"
import style0 from "./CoolingDevice.vue?vue&type=style&index=0&id=07610120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07610120",
  null
  
)

export default component.exports